import React from 'react';
import { Stack, Text } from '@moda/om';
import { colors } from '@moda/tokens';
import CheckmarkIcon from '@moda/icons/checkmark-16';
import { formatPrice } from '@moda/portal-stanchions';
import { LineItem, useCart } from '../../../hooks/useCart';
import { getDiscountedPrice } from '../../../lib/variantUtils/getDiscountedPrice';

import './LineItemPromo.scss';

type Props = {
  item: LineItem;
};

export const LineItemPromo: React.FC<Props> = ({
  item: {
    attributes: {
      markdownPercentage,
      discountedPrice,
      prices: { originalPrice },
      promotionApplicableMessage
    }
  }
}) => {
  const {
    cart: {
      attributes: { giftCode }
    }
  } = useCart();
  if (!promotionApplicableMessage || !giftCode) return null;
  const promoApplied = promotionApplicableMessage.toLowerCase() === 'promo applied';
  const markdownPrice = getDiscountedPrice(Number(originalPrice.price), markdownPercentage);
  const savedAmount = discountedPrice ? Number(markdownPrice - Number(discountedPrice.price)) : 0;
  return (
    <Stack space={1} direction="horizontal">
      {promoApplied && (
        <div className="LineItemPromo__promo-checkmark">
          <CheckmarkIcon color={colors.all['money-good']} />
        </div>
      )}

      <Stack space={0} direction="vertical">
        <Text
          className="LineItemPromo__promo-text"
          treatment="bold1"
          color={promoApplied ? 'money-good' : 'code-red'}
        >
          {promotionApplicableMessage}
        </Text>
        {promoApplied && savedAmount > 0 && (
          <Text
            className="LineItemPromo__saved-amount"
            data-testid="product_promo_applied"
            color="money-good"
          >
            You Saved: {formatPrice(originalPrice.currency, savedAmount)}
          </Text>
        )}
      </Stack>
    </Stack>
  );
};
